import './styles.scss';

import { ChangeEvent, FocusEvent, KeyboardEvent, MouseEvent, ReactElement, Ref, forwardRef } from 'react';

import { FormCheck } from 'react-bootstrap';
import { SwitchInputTypes } from '@/common/SwitchInput/types';
import { getClasses } from '@/utils';
import { withValue } from '@/common/Input/utils';

const SwitchInput = forwardRef(({ ...props }: SwitchInputTypes.Props, ref: Ref<SwitchInputTypes.RefType>): ReactElement => {
  const type = ['checkbox', 'radio', 'switch'].includes(props.type?.toLowerCase()) ? props.type : 'checkbox';
  return (
    <FormCheck
      {...props}
      type={type}
      className={getClasses('SwitchInput', 'Common', props.className)}
      ref={ref}
      onBlur={withValue<FocusEvent<HTMLInputElement>>(props.onBlur, props?.value)}
      onKeyDown={withValue<KeyboardEvent<HTMLInputElement>>(props.onKeyDown, props?.value)}
      onKeyUp={withValue<KeyboardEvent<HTMLInputElement>>(props.onKeyUp, props?.value)}
      onClick={withValue<MouseEvent<HTMLInputElement>>(props.onClick, props?.value)}
      onFocus={withValue<FocusEvent<HTMLInputElement>>(props.onFocus, props?.value)}
      onChange={withValue<ChangeEvent<HTMLInputElement>>(props.onChange, props?.value)}
    />
  );
});
SwitchInput.displayName = 'SwitchInput';

export default SwitchInput;
